import { FileItemModel } from "./file-item.model"

export class SMSModel {
    client_contact_id: number
    to: string
    message: string
    pet_no: number
    doctor: string
    media_url: string
    files: FileItemModel[]

    constructor(
        client_contact_id: number,
        to: string,
        message: string,
        pet_no: number,
        doctor: string,
        media_url: string,
        files: FileItemModel[]
    ) {
        this.client_contact_id = client_contact_id
        this.to = to
        this.message = message
        this.pet_no = pet_no
        this.doctor = doctor
        this.media_url = media_url
        this.files = files
    }
}